import {Nullable} from '../../../app/TypeHelpers'
import {Room} from './Room'

export class MeetingCommentOutline {
    meetingId: number
    meetingCommentId: number
    replySourceId: Nullable<number>
    replySourceContent: Nullable<string>
    meetingName: string
    content: string
    familyName: string
    firstName: string
    roleId: string
    roomList: Room[]
    isWithinTerm: boolean
    hasMailAddress: boolean
    registerDatetime: string

    constructor(
        meetingId: number,
        meetingCommentId: number,
        replySourceId: Nullable<number>,
        replySourceContent: Nullable<string>,
        meetingName: string,
        content: string,
        familyName: string,
        firstName: string,
        roleId: string,
        roomList: Room[],
        isWithinTerm: boolean,
        hasMailAddress: boolean,
        registerDatetime: string,
    ) {
        this.meetingId = meetingId
        this.meetingCommentId = meetingCommentId
        this.replySourceId = replySourceId
        this.replySourceContent = replySourceContent
        this.meetingName = meetingName
        this.content = content
        this.familyName = familyName
        this.firstName = firstName
        this.roleId = roleId
        this.roomList = roomList
        this.isWithinTerm = isWithinTerm
        this.hasMailAddress = hasMailAddress
        this.registerDatetime = registerDatetime
    }
}
